export const brandIntro = [
  "Your website is often the first impression customers have of your brand. We build modern, responsive, secure, and fast websites that attract customers, build credibility, and grow your business.",
  "Startup, established business, or online store — we have a solution tailored to you.",
];

export const whatsIncluded = [
  "Modern UI/UX Design",
  "Responsive Design (Desktop, Tablet & Mobile)",
  "Basic SEO Setup",
  "Fast Performance Optimization",
  "Secure Development Practices",
  "Contact Forms",
  "Social Media Integration",
  "Browser Compatibility",
  "Testing & Quality Assurance",
  "Website Deployment Assistance",
  "One Month Free Technical Support After Launch",
];

export const whyChooseUs = [
  "Modern & Professional Designs",
  "Mobile-First Development",
  "Fast & Secure Websites",
  "SEO-Friendly Development",
  "Clean & Maintainable Code",
  "Transparent Communication",
  "Timely Project Delivery",
  "Reliable Post-Launch Support",
  "Scalable Solutions Built for Future Growth",
];

export const supportPackage = {
  title: "Launch & Support Package",
  subtitle:
    "Included at no additional cost for clients who choose the Business Website, E-Commerce Website, or Custom Web Application packages.",
  benefits: [
    {
      title: "Complimentary First-Year Hosting",
      desc: "The cost of web hosting for your website is covered for the first 12 months (subject to the selected hosting plan and project requirements).",
    },
    {
      title: "Complimentary First-Year Database Hosting",
      desc: "Where applicable, cloud database hosting (e.g., MongoDB Atlas) for the first year is included within the supported usage limits.",
    },
    {
      title: "Free SSL Certificate Setup",
      desc: "Your website will be secured with HTTPS encryption to protect user data and improve trust and search engine rankings.",
    },
    {
      title: "Domain Configuration",
      desc: "We will connect and configure your domain name with your hosting environment to ensure your website is ready for public access.",
    },
    {
      title: "Professional Business Email Setup",
      desc: "We'll configure one professional business email address, helping you present a more credible and professional brand.",
    },
    {
      title: "Performance Optimization",
      desc: "Your website will be optimized for speed, responsiveness, and an excellent user experience across desktop, tablet, and mobile devices.",
    },
    {
      title: "Client Training",
      desc: "Upon project completion, we'll provide a walkthrough of your website or admin dashboard or both so you can confidently manage your content and day-to-day operations.",
    },
    {
      title: "Post-Launch Support",
      desc: "Enjoy 30 days of complimentary technical support after launch for bug fixes, guidance, and minor adjustments.",
    },
  ],
  notes: [
    "Complimentary hosting and database services are provided for the first 12 months only.",
    "Renewal costs after the first year are the client's responsibility.",
    "Enterprise-level hosting requirements, high-traffic applications, or premium third-party services may require additional subscription fees.",
    "Any future feature enhancements or major functionality changes outside the original project scope will be quoted separately.",
  ],
};

export const techStack = [
  {
    label: "Frontend",
    items: ["React.js", "Next.js", "HTML5", "CSS3", "JavaScript / TypeScript", "Tailwind CSS"],
  },
  {
    label: "Backend",
    items: ["Node.js", "Express.js"],
  },
  {
    label: "Database",
    items: ["MongoDB Atlas"],
  },
  {
    label: "Media Storage",
    items: ["Cloudinary"],
  },
  {
    label: "Authentication",
    items: ["JWT Authentication"],
  },
  {
    label: "Payment Integration",
    items: ["Paystack", "Flutterwave", "Stripe (where applicable)"],
  },
  {
    label: "Deployment",
    items: ["Vercel", "Render", "Railway", "DigitalOcean (depending on project requirements)"],
  },
];

export const devopsServices = [
  { service: "Domain Registration", purpose: "Your website address (example.com)" },
  { service: "Web Hosting", purpose: "Keeps your website online" },
  { service: "Server Hosting", purpose: "Required for backend applications" },
  { service: "MongoDB Atlas", purpose: "Cloud database" },
  { service: "Cloudinary", purpose: "Image & Video Storage" },
  { service: "SSL Certificate", purpose: "Website Security (HTTPS)" },
  { service: "Professional Email", purpose: "Business Email Setup" },
  { service: "Payment Gateway", purpose: "Online Payments" },
  { service: "Google Maps API", purpose: "Maps Integration" },
  { service: "Email Services", purpose: "Automated Email Notifications" },
];

export const developmentProcess = [
  { step: "Discovery", desc: "Understanding your business goals and project requirements." },
  { step: "Planning", desc: "Creating the project roadmap, sitemap, and timeline." },
  { step: "Design", desc: "Designing an intuitive and visually appealing user interface." },
  { step: "Development", desc: "Building your website using modern technologies and best practices." },
  { step: "Testing", desc: "Comprehensive testing across browsers, devices, and screen sizes." },
  { step: "Deployment", desc: "Launching your website to a live production environment." },
  { step: "Support", desc: "Providing post-launch support and guidance." },
];

export const projectTimeline = [
  { type: "Landing Page", delivery: "3–5 Business Days" },
  { type: "Portfolio Website", delivery: "5–7 Business Days" },
  { type: "Business Website", delivery: "1–2 Weeks" },
  { type: "Blog Website", delivery: "2–3 Weeks" },
  { type: "E-Commerce Website", delivery: "3–5 Weeks" },
  { type: "Custom Web Application", delivery: "Based on Project Scope" },
];

export const paymentTerms = [
  "70% project deposit before work begins.",
  "30% balance before final deployment.",
  "Any additional features requested outside the agreed project scope will be quoted separately.",
  "Delays in receiving content or feedback from the client may affect delivery timelines.",
];
